import React from 'react';
import './Footer.css';

function Footer({ onNavigateToSection }) {
  const handleLink = (sectionId) => {
    if (onNavigateToSection) {
      onNavigateToSection(sectionId);
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-top-grid">
          {/* Col 1: Brand Info */}
          <div className="footer-brand-col">
            <img src="/images/Logo.png" alt="Deepclariti Logo" className="footer-logo-img" />
            <p className="footer-brand-desc">
              Helping students discover the right future with confidence.
            </p>
          </div>

          {/* Col 2: EXPLORE */}
          <div className="footer-nav-col">
            <h4 className="footer-col-heading">EXPLORE</h4>
            <ul className="footer-links-list">
              <li><button onClick={() => handleLink('home')} className="footer-link-btn">Home</button></li>
              <li><button onClick={() => handleLink('about')} className="footer-link-btn">About</button></li>
              <li><button onClick={() => handleLink('courses')} className="footer-link-btn">Programs</button></li>
              <li><button onClick={() => handleLink('why-us')} className="footer-link-btn">Why Deepclariti</button></li>
              <li><button onClick={() => handleLink('founder')} className="footer-link-btn">Contact</button></li>
            </ul>
          </div>

          {/* Col 3: QUICK LINKS */}
          <div className="footer-nav-col">
            <h4 className="footer-col-heading">QUICK LINKS</h4>
            <ul className="footer-links-list">
              <li><button onClick={() => handleLink('founder')} className="footer-link-btn">Meet V. Swaminathan</button></li>
              <li><button onClick={() => handleLink('about')} className="footer-link-btn">Our Approach</button></li>
              <li><button onClick={() => handleLink('founder')} className="footer-link-btn">Testimonials</button></li>
              <li><button onClick={() => handleLink('founder')} className="footer-link-btn">Book a Consultation</button></li>
              <li><button onClick={() => handleLink('home')} className="footer-link-btn">Privacy Policy</button></li>
            </ul>
          </div>


          <div className="footer-nav-col">
            <h4 className="footer-col-heading">INFORMATION</h4>
            <ul className="footer-links-list">
              <li><button  className="footer-link-btn">Privacy Policy</button></li>
              <li><button className="footer-link-btn">Terms & Conditions</button></li>
             </ul>
          </div>

          {/* Col 4: Social Icons Column (Right Aligned Bottom) */}
          <div className="footer-social-col">
            <div className="footer-social-row">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-circle-icon" aria-label="Facebook">
                f
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-circle-icon" aria-label="Instagram">
                <span style={{ fontSize: '13px', fontStyle: 'italic', fontFamily: 'serif' }}>ig</span>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-circle-icon" aria-label="Twitter">
                <span style={{ fontSize: '13px', fontWeight: 'bold' }}>x</span>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-circle-icon" aria-label="LinkedIn">
                in
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Divider & Copyright Row */}
        <div className="footer-bottom-bar">
          <p className="copyright-text">© 2026 Deepclariti™. All rights reserved.</p>
          <p className="designer-text">
            Designed by{' '}
            <a 
              href="https://ascentbw.com/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="footer-designer-link"
            >
              Ascent Brandworks
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
